import NonIntegerError from "errors/NonIntegerError";
import NonPositiveNumberError from "errors/NonPositiveNumberError";
import splitNumberLine from "./splitNumberLine";

export default function splitArray<T>(array: T[], numberOfOutputArrays: number): T[][] {
    if (numberOfOutputArrays <= 0)
        throw new NonPositiveNumberError("numberOfOutputArrays", numberOfOutputArrays);

    if (!Number.isInteger(numberOfOutputArrays))
        throw new NonIntegerError("numberOfOutputArrays", numberOfOutputArrays);

    if (array.length === 0) return [];

    if (numberOfOutputArrays >= array.length) return array.map(item => [item]);

    const splitPoints = splitNumberLine(array.length, numberOfOutputArrays);

    let outputArray: T[][] = [];
    for (let i = 0; i <= splitPoints.length; i++) {
        const start = i === 0 ? 0 : Math.ceil(splitPoints[i - 1]);
        const end = i === splitPoints.length ? array.length : Math.ceil(splitPoints[i]);

        outputArray.push(array.slice(start, end));
    }

    return outputArray;
}
